import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '../api/client.js';

/**
 * Ne pas retenter les erreurs 4xx (requête invalide, non trouvé, CSRF…) : ce
 * sont des échecs définitifs pour la requête telle qu'elle est formée. Les
 * erreurs réseau/5xx gardent 2 tentatives, valeur par défaut raisonnable pour
 * un outil interne consulté en continu.
 */
function shouldRetry(failureCount: number, error: unknown): boolean {
  if (error instanceof ApiError && error.status >= 400 && error.status < 500) {
    return false;
  }
  return failureCount < 2;
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: shouldRetry,
        staleTime: 15_000,
        refetchOnWindowFocus: true,
      },
      mutations: {
        retry: false,
      },
    },
  });
}
